import Animated from 'react-native-reanimated'
import styled from 'styled-components/native'

type ScaleWrapperProps = {
  markerSlotHeight: number
}

export const ScaleWrapper = styled.View<ScaleWrapperProps>`
  width: 100%;
  position: relative;
  padding-top: ${({ markerSlotHeight }) => markerSlotHeight}px;
`

type MarkerProps = {
  iconSize: number
}

export const Marker = styled(Animated.View)<MarkerProps>`
  position: absolute;
  top: 0;
  /* Without an explicit width, the container shrinks to the glyph's advance,
     which does not equal iconSize — that would offset the marker's centre by
     (iconSize - advance) / 2. Pinning width to iconSize and centring the
     glyph keeps the container's centre at exactly left + iconSize / 2; the
     translate then shifts that centre onto the animated \`left\` value. */
  width: ${({ iconSize }) => iconSize}px;
  align-items: center;
  transform: translateX(${({ iconSize }) => -iconSize / 2}px);
`

export const LevelContainer = styled.View`
  display: flex;
  width: 100%;
  flex-direction: row;
  gap: ${({ theme }) => theme.metrics.baseMargin / 8}px;
`

type LevelBlockProps = {
  isFirstLevel: boolean
  isLastLevel: boolean
}

export const LevelBlockContainer = styled.View`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.metrics.baseMargin / 8}px;
  flex: 1;
`

export const LevelBlock = styled(Animated.View)<LevelBlockProps>`
  height: ${({ theme }) => theme.metrics.baseMargin / 2}px;
  border-top-left-radius: ${({ isFirstLevel, theme }) =>
    isFirstLevel ? theme.metrics.borderRadius.small : 0}px;
  border-top-right-radius: ${({ isLastLevel, theme }) =>
    isLastLevel ? theme.metrics.borderRadius.small : 0}px;
  border-bottom-left-radius: ${({ isFirstLevel, theme }) =>
    isFirstLevel ? theme.metrics.borderRadius.small : 0}px;
  border-bottom-right-radius: ${({ isLastLevel, theme }) =>
    isLastLevel ? theme.metrics.borderRadius.small : 0}px;
`

export const LevelLabel = styled.View`
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-top: ${({ theme }) => theme.metrics.baseMargin / 2}px;
`
